export class Offer {
    constructor(
        public id = '',
        public title = '',
        public type: 'general' | 'hardware' | 'training' = 'training',
        public info = '',
        public price = 0,
        public createdBy = '',
        public createdAt = '',
        public createdAtUnix: number = 0,
        public updatedBy = '',
        public updatedAt = '',
        public updatedAtUnix: number = 0,
        public visible = false,
        public deleted = false,
    ) {}
}
